import { type TaskConfig } from "@repo/ui";

export const filterTasksForCalendar = (tasks: TaskConfig[]) => {
  return tasks
    .filter((task) => task.enabled)
    .filter((task) => task.context?.includes("CALENDAR"))
    .map((task) => {
      let updatedSubTypes = task.subTypes
        ?.filter((subType) => subType.enabled)
        .filter(
          (subType) => subType.context?.includes("CALENDAR") || !subType.context
        );

      if (task.name_key === "appointment") {
        updatedSubTypes = updatedSubTypes?.filter(
          (subType) => subType.name_key !== "followUp"
        );

        if (!updatedSubTypes?.some((subType) => subType.name_key === "BOKA")) {
          updatedSubTypes = [
            ...(updatedSubTypes || []),
            { name_key: "BOKA", context: ["CALENDAR"] },
          ];
        }
      }

      return {
        ...task,
        subTypes: updatedSubTypes,
      };
    });
};
